import axiosInstance from '@/api/axiosInstance';

export interface UploadResponse {
  url: string;
  filename: string;
  size: number;
  mimetype: string;
}

export interface UploadProgressInfo {
  loaded: number;
  total: number;
  percentage: number;
}

export const uploadFile = async (
  file: File,
  onProgress?: (info: UploadProgressInfo) => void,
  signal?: AbortSignal
): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axiosInstance.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    signal,
    onUploadProgress: (evt) => {
      if (!onProgress || !evt.total) return;
      const percentage = Math.round((evt.loaded * 100) / evt.total);
      onProgress({ loaded: evt.loaded, total: evt.total, percentage });
    },
  });

  return response.data as UploadResponse;
};
